<template>
  <div class="my_order">
    <div class="order_main">
      <div class="order_left">
        <user-tab></user-tab>
      </div>

      <div class="order_right">
        <keep-alive :max="2">
          <router-view></router-view>
        </keep-alive>
      </div>
    </div>
  </div>
</template>

<script>
import userTab from "./../../components/user/user_tab";
export default {
  components: {
    userTab
  },
  data() {
    return {};
  },
  mounted() {
    var _this = this;
    for (let i of _this.$store.state.headerTabList) {
      i.isSelected = false;
      if (i.name == "我的订单") {
        i.isSelected = true;
      }
    }
  },

  methods: {}
};
</script>
<style lang="scss">
.el-select .el-input.is-focus .el-input__inner {
  border-color: #3455d3 !important;
}
.el-date-table td.end-date span,
.el-date-table td.start-date span {
  background: #3455d3 !important;
}
.el-date-table td.in-range div,
.el-date-table td.in-range div:hover,
.el-date-table.is-week-mode .el-date-table__row.current div,
.el-date-table.is-week-mode .el-date-table__row:hover div {
  background: #eff2ff !important;
}

.el-date-table td span,
.el-date-table td.start-date div,
.el-date-table td.end-date div {
  border-radius: 0 !important;
}
#range_date {
  .range_date {
    padding: 0px 10px !important;
    border-radius: 2px !important;

    input.el-range-input {
      width: 78px !important;
      height: 28px !important;
      border: none !important;
      padding-left: 0 !important;
      padding-right: 0 !important;
    }

    .el-range-separator {
      margin-right: 15px !important;
      line-height: 28px !important;
    }
  }
  .el-date-editor .el-range__icon {
    line-height: 28px !important;
    margin-left: 0;
  }
  .el-date-editor .el-range__close-icon {
    display: none;
  }
  .el-range-editor.is-active,
  .el-range-editor.is-active:hover,
  .el-input__inner:focus {
    border-color: #3455d3;
  }
}
.screen_input {
  font-size: 12px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  & > div {
    // margin-right: 29px;
    margin-bottom: 24px;
    // width: 266px;
  }
  // & > div:nth-child(3n) {
  //   margin-right: 0;
  // }
  .screen {
    width: 210px;
    height: 30px;
    margin-left: 4px;
    .el-input .el-input__suffix {
      width: 31px !important;
    }
    input {
      height: 30px;
      padding: 0 15px !important;
      border: 1px solid #dcdfe6;
      font-size: 12px;
      border-radius: 2px !important;
    }
    input:hover,
    input:active,
    input:focus {
      border-color: #3455d3 !important;
    }
    input::-webkit-input-placeholder {
      font-size: 12px;
    }
  }
}
.my_order {
  background: #eef0f3;
  overflow: hidden;
  .order_main {
    width: 1200px;
    display: flex;
    margin: 0 auto;
    justify-content: space-between;
    margin-top: 15px;
    margin-bottom: 55px;
    .order_left {
      // width: 291px;
      width: 210px;
      // height: 923px;
      background: #fff;
    }
    .order_right {
      // width: 897px;
      width: 980px;
      margin-bottom: 20px;
    }
  }
}
</style>
